var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0868 15.3076C28.868 14.485 28.2257 13.8394 27.4097 13.6207C25.9305 13.2215 20 13.2215 20 13.2215C20 13.2215 14.0694 13.2215 12.5903 13.6207C11.7743 13.8394 11.1319 14.485 10.9132 15.3076C10.5173 16.7968 10.5173 19.8999 10.5173 19.8999C10.5173 19.8999 10.5173 23.0031 10.9132 24.4922C11.1319 25.3149 11.7743 25.9328 12.5903 26.1514C14.0694 26.5506 20 26.5506 20 26.5506C20 26.5506 25.9305 26.5506 27.4097 26.1514C28.2257 25.9328 28.868 25.3114 29.0868 24.4922C29.4826 23.0031 29.4826 19.8999 29.4826 19.8999C29.4826 19.8999 29.4826 16.7968 29.0868 15.3076ZM18.0625 22.7185V17.0814L23.0173 19.8999L18.0625 22.7185Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.143e34076e36779e54c7e8ec0384b2ea.svg";
export { ForwardRef as ReactComponent };